import React from 'react';
export function ClosingSection() {
  return <section className="w-full bg-gradient-to-b from-[#111116] to-[#1a1a22] py-10 md:py-16 px-4 relative overflow-hidden" data-id="element-44">
      {/* Glow decorativo */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-[#e53935]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-45"></div>

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-46">
        <h2 className="text-2xl md:text-4xl font-black text-white mb-2 leading-tight" data-id="element-47">
          La diferencia entre intentarlo
        </h2>
        <p className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043] mb-8 leading-tight" data-id="element-48">
          y hacerlo en serio.
        </p>

        <div className="w-16 h-0.5 bg-gradient-to-r from-[#e53935] to-[#ff7043] mx-auto mb-8" data-id="element-49"></div>

        <div className="space-y-4 mb-10" data-id="element-50">
          <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-lg mx-auto" data-id="element-51">
            Podés seguir viendo contenido suelto y aprender lentamente.
          </p>
          <p className="text-gray-200 text-base md:text-lg font-semibold leading-relaxed max-w-lg mx-auto" data-id="element-52">
            O podés seguir un método estructurado que te guíe paso a paso.
          </p>
          <p className="text-white font-black text-lg md:text-xl mt-6 bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 inline-block" data-id="element-53">
            Método Barber Pro está pensado para quienes quieren aprender
            barbería de verdad.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-54">
          <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-xl inline-block text-center" aria-label="Empezar ahora" data-id="element-55">
            👉 EMPEZAR AHORA
          </a>
        </div>
      </div>
    </section>;
}